import { supabase } from './supabaseClient';

export async function signInWithGitHub() {
  if (!supabase) {
    console.error('Supabase client not initialized');
    return { error: new Error('Supabase not configured') };
  }

  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'github',
    options: {
      redirectTo: window.location.origin + '/canvas',
      scopes: 'read:user user:email'
    }
  });

  return { data, error };
}

export async function signOut() {
  if (!supabase) {
    console.error('Supabase client not initialized');
    return { error: new Error('Supabase not configured') };
  }

  const { error } = await supabase.auth.signOut();
  return { error };
}

export async function getSession() {
  if (!supabase) {
    return { data: { session: null }, error: null };
  }

  const { data, error } = await supabase.auth.getSession();
  return { data, error };
}

export function onAuthStateChange(callback) {
  if (!supabase) {
    return { data: { subscription: { unsubscribe: () => {} } } };
  }

  return supabase.auth.onAuthStateChange(callback);
}
